
import { Component, OnInit, ViewChild } from '@angular/core';
import { AppInformationService, ArkUnitOfWork, UtilityService } from 'app/core/core.module';
import { DxDataGridComponent } from 'devextreme-angular';

@Component({
    selector: 'app-construction',
    templateUrl: './construction.component.html',
    styleUrls: ['./construction.component.scss'],
    standalone: true,
    imports: [],
})
export class ConstructionComponent implements OnInit {
    people: any[];
    @ViewChild('dataGrid') dataGrid: DxDataGridComponent;

    constructor(private appInfo: AppInformationService, private utility: UtilityService, private uow: ArkUnitOfWork) {}

    async ngOnInit() {
    }

    async getData() {
    }

    onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift(
            {
                location: 'before',
                template: 'toolbarButtons',
            },
            {
                template: 'toolbarText',
                location: 'after',
            }
        );
    }
}
